module.exports = __webpack_public_path__ + "img/BRCA2_Plasma.3b158316.png";